<!-- 导入弹框 -->
<template>
  <div class="batch-import">
    <e-dialog
      popup-width="600px"
      :dialog-title="dialogTitle"
      :center-dialog-visible="importVisible"
      sub-btn="确认导入"
      @resetPopupData="resetPopupData"
      @submitPopupData="importSubmitPopupData('ruleForm')"
    >
      <el-form ref="uploadForm" size="small">
        <div v-if="tipMessage" class="hint">
          <span>提示：</span>
          {{ tipMessage }}
        </div>
        <el-form-item label="下载模版:" label-width="100px" prop="">
          <el-button
            type="text"
            class="download-text"
            @click="downPurchaseTemplate"
          >
            {{ downLoadFileName }}
          </el-button>
        </el-form-item>
        <el-form-item label="上传模板:" label-width="100px">
          <eui-upload
                  ref="upload"
                  :auto-upload="autoUpload"
                  :file-list="fileArr"
                  :action="fileUrl"
                  :headers="headers"
                  :show-file-list="true"
                  :limit="1"
                  accept=".xlsx,.xls,"
                  :text="btnText"
                  text="上传分供应商录入表"
                  tip="格式支持Excel"
                  @handleSuccess="uploadSuccess"
          ></eui-upload>
        </el-form-item>
      </el-form>
    </e-dialog>
  </div>
</template>

<script>
import eDialog from '@/modules/projectA/components/common/e-dialog';
import { epecToken } from '@/modules/projectA/utils/globalData';
import utils from '@/modules/projectA/utils/utils';
import api from '@/modules/projectA/api/user';

export default {
  components: { eDialog },
  props: {
    importVisible: {
      type: Boolean,
      default: false,
    },
    fileUrl: String,
    downLoadMethod: String, // 通过接口下载的模板
    downloadFileUrl: String, // 模板上传到服务器下载的地址
    templateName: String,
    dialogTitle: String,
    downLoadFileName: String,
    btnText: {
      type: String,
      default: '选择文件',
    },
    tipMessage: String,
  },
  data() {
    return {
      fileList: [],
      fileArr: [],
      uploadLoading: false,
      headers: epecToken,
      downloadUrl: '',
      privateUpload: {},
      autoUpload: false, // 修改
    };
  },
  methods: {
    importSubmitPopupData() {
      this.$refs.upload.submit();
    },
    uploadSuccess(res) {
      if (res.code === '200') {
        this.$message.success('文件上传成功。');
        this.$emit('update:importVisible', false);
        this.$emit('updatePage', res.data);
      } else {
        this.$message.warning(res.message);
      }
    },
    async downPurchaseTemplate() {
      if (this.downLoadMethod) {
        const res = await api[this.downLoadMethod]();
        utils.downFile(res, this.templateName);
      }
      if (this.downloadFileUrl) {
        window.open(this.downloadFileUrl);
      }
    },
    // 关闭弹窗
    resetPopupData() {
      this.$emit('update:importVisible', false);
    },
  },
};
</script>
<style lang="scss" scoped>
.hint {
  word-wrap: break-word;
  color: #666666;
  font-size: 14px;
  line-height: 14px;
  background: #e8efff;
  padding: 15px 10px;
  margin-bottom: 20px;
  span {
    color: #f0250f;
  }
}
.batch-import {
  .download-text {
    text-decoration: underline;
    color: #0064c8;
    font-size: 14px;
    cursor: pointer;
  }

  .upload-file {
    position: relative;
    .error {
      position: absolute;
      left: 0;
      top: 28px;
      color: red;
      font-size: 12px;
    }
    ::v-deep .el-button {
      border-radius: 0;
      min-width: 80px;
      height: 30px;
    }
  }
  ::v-deep.el-dialog__body {
    padding: 10px;
  }
  ::v-deep.el-dialog__header {
    background: #f5f5f5;
    height: 40px;
    padding: 0 20px;
    line-height: 40px;
    .el-dialog__headerbtn {
      top: 8px;
    }
    .el-dialog__title {
      font-size: 14px;
    }
  }

  ::v-deep .el-dialog__footer {
    display: flex;
    justify-content: center;
    .el-button {
      border-radius: 0;
      min-width: 80px;
      height: 30px;
    }
  }
}
</style>
